import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError, type U2000ApiErrorResult } from '../../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../../u2000Core/context/toast/U2000ToastContext';
import { NS } from '../U3204';
import {
  doListProductHelpSources,
  luHandleAppiError,
  type U3204ProductHelpSource,
} from '../U3204Service';

export function useU3204ProductHelpSourcesHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation(NS);
  const toast = useToast();
  const [sources, setSources] = useState<U3204ProductHelpSource[]>([]);
  const [loading, setLoading] = useState(false);

  const loadSources = useCallback(async () => {
    setLoading(true);
    try {
      const response = await doListProductHelpSources(axios);
      const rows = response.data?.results ?? [];
      setSources(rows);
      return rows;
    } catch (error: unknown) {
      const errorResult = U2000HandleApiError(error as Error, t, NS, luHandleAppiError) as U2000ApiErrorResult;
      if (errorResult.genericErrors?.length) {
        errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
      }
      return [];
    } finally {
      setLoading(false);
    }
  }, [axios, t, toast]);

  return { sources, loading, loadSources };
}
